import { z } from 'zod';
import { projectSchema } from './replay.js';

export const telemetryModeSchema = z.enum(['off', 'level', 'full']);
export const telemetryPolicySchema = z.strictObject({
  mode: telemetryModeSchema,
  snapshotIntervalMs: z.number().int().min(1000).max(60000),
  minUploadIntervalMs: z.number().int().min(500).max(30000),
  maxUploadIntervalMs: z.number().int().min(1000).max(120000),
  flushThresholdBytes: z.number().int().min(16 * 1024).max(1024 * 1024),
}).refine(policy => policy.maxUploadIntervalMs >= policy.minUploadIntervalMs, {
  message: 'maxUploadIntervalMs must be greater than or equal to minUploadIntervalMs',
  path: ['maxUploadIntervalMs'],
});
export const DEFAULT_TELEMETRY_POLICY = {
  mode: 'full',
  snapshotIntervalMs: 3000,
  minUploadIntervalMs: 2000,
  maxUploadIntervalMs: 10000,
  flushThresholdBytes: 128 * 1024,
} as const satisfies z.infer<typeof telemetryPolicySchema>;
export const managedProjectSchema = projectSchema.extend({ telemetry: telemetryPolicySchema });
export const createProjectSchema = projectSchema.extend({ name: projectSchema.shape.name.trim().min(1) });
export const updateProjectSchema = z.strictObject({ name: projectSchema.shape.name.trim().min(1), telemetry: telemetryPolicySchema });
export const managedProjectsResponseSchema = z.strictObject({ requestId: z.string(), projects: z.array(managedProjectSchema).max(100) });
export const telemetryConfigResponseSchema = z.strictObject({
  requestId: z.string(),
  projectId: projectSchema.shape.id,
  telemetry: telemetryPolicySchema,
});
export type ManagedProject = z.infer<typeof managedProjectSchema>;
export type TelemetryPolicy = z.infer<typeof telemetryPolicySchema>;
